import { TFunction } from "i18next"


const MONTHS = [
  { value: 1, label: 'general.calendar.january' },
  { value: 2, label: 'general.calendar.february' },
  { value: 3, label: 'general.calendar.march' },
  { value: 4, label: 'general.calendar.april' },
  { value: 5, label: 'general.calendar.may' },
  { value: 6, label: 'general.calendar.june' },
  { value: 7, label: 'general.calendar.july' },
  { value: 8, label: 'general.calendar.august' },
  { value: 9, label: 'general.calendar.september' },
  { value: 10, label: 'general.calendar.october' },
  { value: 11, label: 'general.calendar.november' },
  { value: 12, label: 'general.calendar.december' },
]

export function getMonths(t: TFunction) {
  return MONTHS.map(month => ({ value: month.value, label: t(month.label) }))
}

export function getYears(currentYear: number, calendarYearRange: number) {
  const totalYears = (calendarYearRange * 2) + 1

  return [...Array(totalYears)].map((_, index) => {
    const year = (currentYear - calendarYearRange) + index
    return { value: year, label: year.toString() }
  })
}

export function applyWeekdaysLabels(weekdays: HTMLCollection, t: TFunction) {
  weekdays[0].innerHTML = t('general.calendar.sunday') || 'Sun'
  weekdays[1].innerHTML = t('general.calendar.monday') || 'Mon'
  weekdays[2].innerHTML = t('general.calendar.tuesday') || 'Tue'
  weekdays[3].innerHTML = t('general.calendar.wednesday') || 'Wed'
  weekdays[4].innerHTML = t('general.calendar.thursday') || 'Thu'
  weekdays[5].innerHTML = t('general.calendar.friday') || 'Fry'
  weekdays[6].innerHTML = t('general.calendar.saturday') || 'Sex'
}
